module.exports = __webpack_public_path__ + "static/img/背景.db7df34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/背景.png
// module id = SVky
// module chunks = 1